import { USER_DELETE_URL ,GET_EDIT_USER_PROFILE,GET_UPDATE_USER_PROFILE, DELETE_UPLOAD_DOCUMENT} from "../../config/adminUrlConfig";
import { ApiService } from "../../config/apiServices";
import { GET_USER_PROFILE,LOGIN_MOBILE_OTP, INSTITUTION_LIST,GET_USER_CATEGORY_TYPE,
  
   UPDATE_USER_PROFILE_DETAILS,UPDATE_USER_MOBILE,EMAIL_OTP_GENERATION_URL,UPDATE_USER_EMAIL,UPLOAD_DOCUMENT, GET_KIT_SIZE_LIST, CHECK_FIELD_UPDATE } from "../../config/user/userUrlConfig";
import { FileUploadService } from "../../config/apiServices";


export const getAllUserProfileList = (category_main_id,user_id) => {
    return ApiService.get(`${GET_USER_PROFILE}${category_main_id}/${user_id}`);
  };

  export const getInstitutionList = () => {
    return ApiService.get(INSTITUTION_LIST);
  };

  export const getKitSizeList = () => {
    return ApiService.get(GET_KIT_SIZE_LIST);
  };

  export const checkFieldUpdate = (fieldName) => {
    return ApiService.get(`${CHECK_FIELD_UPDATE}?checkFieldUpdate=${fieldName}`);
  };

  export const getUserCategoryTypes = (user_category_main, category_type, orgnization_city_id) => {
    return ApiService.get(`${GET_USER_CATEGORY_TYPE}?user_category_main=${user_category_main}&category_type=${category_type}&orgnization_city_id=${orgnization_city_id}`);
  };

  
  export const deletUserProfile = () => {
    return ApiService.delete(USER_DELETE_URL);
  }





  // Submit combined profile updates
export const updateUserProfileDetails = (data) => {
  return ApiService.post(UPDATE_USER_PROFILE_DETAILS, data);
};

// ✅ Send OTP to new mobile number
export const sendMobileOtp = (mobile) => {
  return ApiService.post(LOGIN_MOBILE_OTP, { mobile });
};

// ✅ Verify OTP for mobile number
// export const verifyMobileOtp = (mobile, otp) => {
//   return ApiService.post(OTP_VERIFICATION_MOBILE, { mobile, otp });
// };

// ✅ Resend OTP
// export const resendMobileOtp = (mobile) => {
//   return ApiService.post(RESET_LOGIN_MOBILE, { mobile });
// };

export const updateUserMobileNumber = (mobile, otp) => {
  return ApiService.post(UPDATE_USER_MOBILE, {  mobile, otp  });
};


export const sendEmailOtp = (email) => {
  return ApiService.post(EMAIL_OTP_GENERATION_URL, { email });
}

export const updateUserEmail = (email, otp) => {
  return ApiService.post(UPDATE_USER_EMAIL, { email, otp });
}

// export const verifyEmailOtp = (email, otp) => {
//   return ApiService.post(EMAIL_OTP_VERIFICATION_URL, { email, otp });
// }


// Upload a single supportive document. Expects FormData with keys:
// - doc_name (string), file (File/Blob), user_id (string|number)
export const uploadUserDocument = (formData) => {
  return FileUploadService.post(UPLOAD_DOCUMENT, formData);
}

// export const  notificationListApi = () => {
//       return ApiService.get(GET_NOTIFICATION_URL);
// };

// export const  notificationUpdateApi = () => {
//       return ApiService.post(UPDATE_NOTIFICATION_URL);
// };



export const getAlleditProfileList = async(
  page=1,
  perPage=10,
  searchTerm="",
  statusFilter="",

)=>{
  return ApiService.get(`${GET_EDIT_USER_PROFILE}?number=${perPage}&page=${page}&search=${searchTerm}&status=${statusFilter}`)
}

export const getSingleUpdateProfileData=(id)=>{
return ApiService.get(`${GET_UPDATE_USER_PROFILE}/${id}`)
}


export const deleteUploadDocument=(id)=>{
  return ApiService.delete(`${DELETE_UPLOAD_DOCUMENT}/${id}`)
}
